<template>

  <div
    :class="pageClass"  
  >

    <loading theme="dark" :center="true" v-if="pageState === 'loading'"/>

    <v-container
      v-else-if="pageState === 'success'"
      fluid
      class="pa-0 ma-0 full-width full-height overflow-y-auto"
    >
      <v-row
        class="pa-0 ma-0"
        align="center"
        justify="center" 
      >
        <v-col
          cols="12"
          lg="6"
          md="8"
          sm="10"
          xs="12"
          class="py-5 full-height"      
        >
            <v-card
              color="ycmd-very-lightest-gray"
              
            >              
                <v-card-title
                  class="py-0 my-0"
                >             
                {{successMessage}}                                 
                </v-card-title>
                <v-card-actions>

                <v-btn
                    color="ycmd-lightest-blue"
                    @click="complete"
                >
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-else
      fluid
      class="pa-0 ma-0 full-width full-height overflow-y-auto"
    >
      <v-row
        class="pa-0 ma-0"
        align="center"
        justify="center" 
      >
        <v-col
          cols="12"
          lg="6"
          md="8"
          sm="10"
          xs="12"
          class="py-5 full-height"      
        >
          <v-form
            ref="messageForm"
            v-model="valid"
            @submit.prevent="sendMessage"
          >
            <v-card
              width="100%"
              height="100%"
              color="ycmd-very-lightest-gray"
              
            >              
                <v-card-text
                  class="py-0 my-0"
                >
                <page-title :groupData="groupData"/>


              <v-row
                class="pa-0 ma-0"
                v-for="(item) in fields"
                :key="`field_${item.id}`"
              >
                <v-col 
                  class="pa-0 ma-0"
                >   
                  <data-collection-item
                    :collectionItem="item"
                    v-model="values[item.id]"
                    :attribute.sync="values[`attribute_${item.id}`]"
                    :backgroundColor="entryBackground"
                    />
                </v-col>
              </v-row>
                                        
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="ycmd-lightest-blue"
                    :disabled="sending || !valid"
                    type="submit"
                >
                    Send
                </v-btn>
                <v-btn
                    @click="clear()"
                    text
                >
                    Cancel
                </v-btn>
                </v-card-actions>
            </v-card>
          </v-form>

        </v-col>
      
      </v-row>
    </v-container>

  </div> 

</template>

<script>
import DatePicker from '@/components/datetime/date-picker';
import dataClient from '@/graphql/clients/axios';
import Loading from '@/components/loading-elipsis';
import DataCollectionItem from './data-collection-item'
import Title from './title'
export default {
  props: {
  
  },
  data: () => ({
    validation_rules: {
        required: value => !!value || 'Required.',
        //min: v => v.length >= 8 || 'Min 8 characters',
        phone: (number, other) => {
            const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
            return pattern.test(number) || 'Invalid number. Please use (###) ###-####';
        },
        validateEmail: (v, message) => {
          const emailRegex = /.+@.+\..+/
          if (!v) {
            return true
          }
          return emailRegex.test(v) || (message || 'Invalid Email address')
        }
    },
    masks: {
        phone: '(###) ###-####'
    },
    pageState: 'loading',
    sending: false,
    valid: false,   
    fieldsJson: null,
    values: {}
  }),
  methods: {
    sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  } ,
    complete () {

      window.location.reload(true)
      //this.clearForm()
      //this.pageState = 'message'
    },
    async sendMessage () {

      let parameters = []
      console.log('this.$route.params.id', this.$route.params.id)

      parameters.push({
        id: 'group_id',
        value: this.$route.params.id
      })

      for (let id in this.values) {
        parameters.push({
          id: id,
          value: this.values[id]
        })
      }

      this.sending = true

/*
      let copyParameters = JSON.parse(JSON.stringify(parameters)) 
      let response
      for (let i = 0; i < 100; i++) {
        
        for (let j = 0; j < parameters.length; j++) {
          console.log(' ', parameters[j].id, parameters[j].value)
          switch (parameters[j].id) {
            case 'Name':
            case 'Provider Name':
              parameters[j].value= copyParameters[j].value+`_${i}`
              break
            case 'dob':
              let pieces = copyParameters[j].value.split('/')
              pieces[2] = 1940 + i
              parameters[j].value = pieces.join('/')
              break 
            case 'Phone':
              let phonepieces = copyParameters[j].value.split('-')
              phonepieces[2] = (1000 + i)+''
              parameters[j].value = phonepieces.join('-')
              break
          }
          
        }
        console.log('parameters', parameters)
    //  }
  
        response = await dataClient('providerPageSet', {operation: 'group_message', parameters: parameters})
        await this.sleep(100)
      }
      */
      let response = await dataClient('providerPageSet', {operation: 'group_message', parameters: parameters})
      let success = false
      if (Array.isArray(response)) {
        this.sendResponseArray = response
        if (this.sendResponse.status && this.sendResponse.status.value === 'success') {
          success = true
        }
      }

      if (success) {
        let message = this.sendResponse.sent_message_response ? this.sendResponse.sent_message_response.value : null
        if (!message) {
          message = `Your message has been sent`
        }

        this.successMessage = message

        this.pageState = 'success'
        //this.$toasted.success(message);
        //this.clearForm()
      }
      else {
        this.$toasted.error(`An error occurred.  Please try again or call the office`);
      }

      this.sending = false
    }
  },
  computed: {
    pageClass () {
      let classes = `full-width full-height group-page group-page-${this.$route.params.id}`

      return classes
    },
    messageValidation () {
      if (this.message) {
        return [] 
      } else {
        if (this.messageType && this.messageType !== 'Other') {
          return []
        }
      }
      return ['Required.']
    },
    groupData () {
      let ret = {}
      if (this.groupDataArray && this.groupDataArray.length) {
        this.groupDataArray.map(d => {
          ret[d.id] = d
        })
      }
      return ret
      
    },
    sendResponse () {
      let ret = {}
      if (this.sendResponseArray && this.sendResponseArray.length) {
        this.sendResponseArray.map(d => {
          ret[d.id] = d
        })
      }
      return ret
    },
    fields () {
      let arr = []
      if (this.fieldsJson) {
        arr = JSON.parse(this.fieldsJson)
      }
      return arr
    },
    entryBackground () {
      if (this.groupData && this.groupData.entry_background) {
        return this.groupData.entry_background.value
      }
    }

  },
  components: {
    'date-picker': DatePicker,
    loading: Loading,
    'data-collection-item': DataCollectionItem,
    'page-title': Title
  },
  async mounted () {
  
    let parameters = []
    parameters.push({
      id: 'group_id',
      value: this.$route.params.id
    })
    let response = await dataClient('providerPageGet', {operation: 'get_group', parameters: parameters})
    console.log('response', response)

    let hasError = false
    if (Array.isArray(response) ) {
      this.groupDataArray = response
      if (!this.groupData.group_name) {
        hasError = true
      }
    } else {
      hasError = true
    }
    
    if (hasError) {
      this.$router.push({ name: '404NoOptions'})
    } else {
      if (this.groupData.fields) {
        this.fieldsJson = this.groupData.fields.value

        let arr = JSON.parse(this.fieldsJson)

        arr.map(f => {
          //default can text to true
          if (f.type === 'phone') {
            this.values[`attribute_${f.id}`] = true
          }
        })

      }
      this.pageState = 'complete'
    }
    
  }
}
</script>

<style scoped>
/* This overrides the global html/body background for this page only */
.group-page-513e560f2c0a62a971000015 {
  background: #31bcac 
}
.group-page-513e560f2c0a62a971000015 {
  background: #31bcac 
}

.group-page-5424763114238ba97ea57f85 {
  background: #31bcac
}
.group-page-5424763114238ba97ea57f85 {
  background: #31bcac 
}

</style>